import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const TABS = [
  { key: 'conversations', label: 'Conversations', to: '/admin/communication', match: '/admin/communication' },
  { key: 'inquiries', label: 'General Inquiries', to: '/admin/inquiries', match: '/admin/inquiries' },
  { key: 'emails', label: 'Email Activity', to: '/admin/emails', match: '/admin/emails' },
  { key: 'review', label: 'Needs Review', to: '/admin/needs-review', match: '/admin/needs-review' },
];

// One Inbox: four record types kept distinct, each tab opens its connected workspace
export const InboxTabs = () => {
  const { token } = useAuth();
  const { pathname } = useLocation();
  const [c, setC] = useState({});
  useEffect(() => {
    const h = { headers: { Authorization: `Bearer ${token}` } };
    const loadReview = () => axios.get(`${API_URL}/api/admin/review-items/summary`, h).then((r) => setC((p) => ({ ...p, review: r.data?.open }))).catch(() => {});
    window.addEventListener('gg-review-changed', loadReview);
    return () => window.removeEventListener('gg-review-changed', loadReview);
  }, [token]);
  useEffect(() => {
    const h = { headers: { Authorization: `Bearer ${token}` } };
    axios.get(`${API_URL}/api/admin/conversations/summary`, h).then((r) => setC((p) => ({ ...p, conversations: r.data?.unread_conversations }))).catch(() => {});
    axios.get(`${API_URL}/api/admin/inquiries/stats`, h).then((r) => setC((p) => ({ ...p, inquiries: r.data?.new }))).catch(() => {});
    axios.get(`${API_URL}/api/admin/emails/failed`, h).then((r) => setC((p) => ({ ...p, emails: r.data?.length }))).catch(() => {});
    axios.get(`${API_URL}/api/admin/review-items/summary`, h).then((r) => setC((p) => ({ ...p, review: r.data?.open }))).catch(() => {});
  }, [token, pathname]);
  return (
    <div className="gg-ws bg-[#f4f2ed] px-5 sm:px-9 pt-6" data-testid="inbox-tabs">
      <p className="text-[9px] tracking-[0.16em] font-bold text-[#7a7c6d]">INBOX</p>
      <div className="flex gap-2 flex-wrap mt-2" role="tablist" aria-label="Inbox category">
        {TABS.map((t) => {
          const active = pathname.startsWith(t.match);
          return (
            <Link key={t.key} to={t.to} role="tab" aria-selected={active}
              className={`px-3.5 py-2 rounded-md text-xs font-semibold border transition-colors ${active ? 'bg-[#252a20] text-white border-[#252a20]' : 'bg-[#fbfaf7] border-[#dcded2] text-[#5f6455] hover:bg-white'}`} data-testid={`inbox-tab-${t.key}`}>
              {t.label}{c[t.key] ? <span className={`ml-1.5 text-[10px] px-1.5 rounded ${active ? 'bg-white/15' : 'bg-[#fff0e4] text-[#b75b28]'}`}>{c[t.key]}</span> : null}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default InboxTabs;
